import React from "react";

import { Trans } from "@lingui/react/macro";

import EventNotification, {
  EventNotificationTitle,
  ReturnToRead,
} from "@app/booking/components/EventNotification";

const PastEvent = () => (
  <EventNotification>
    <EventNotificationTitle>
      <Trans>The event you're trying to view is in the past.</Trans>
    </EventNotificationTitle>
    <ReturnToRead />
  </EventNotification>
);

export default PastEvent;
